import { SearchFilters } from '@cinch-nx/data-search'
import { getOrderedUrlPathSegmentFilters } from '../get-ordered-url-path-segment-filters/get-ordered-url-path-segment-filters'
import { transformFilterArrayToString } from '../transform-filter-array-to-string/transform-filter-array-to-string'

export const getSearchPageTitle = (
  pathSegmentFilters: Partial<SearchFilters>,
  formattedMake?: string,
  formattedModel?: string,
  formattedTrim?: string,
  formattedBodyType?: string,
  hasMatchingVehicleRecentlyBeenInStock?: boolean,
): string => {
  const titleOrderedFilterArray =
    getOrderedUrlPathSegmentFilters(pathSegmentFilters)

  if (
    titleOrderedFilterArray.length === 0 ||
    hasMatchingVehicleRecentlyBeenInStock === false
  )
    return 'Used cars for sale or on finance'

  const title = transformFilterArrayToString(
    titleOrderedFilterArray,
    formattedMake,
    formattedModel,
    formattedTrim,
    formattedBodyType,
  )

  return `Used ${title.trim()} cars for sale or on finance`
}
